import Vue from 'vue'
import Axios from 'axios'

let user = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')) : null;
let token = user !== null ? user.companies !== undefined ? JSON.parse(localStorage.getItem('companytoken')) : JSON.parse(localStorage.getItem('stafftoken')) : null;

let hasPermission = false;

Vue.prototype.$can = function(permission) {
    if(user !== null) {
        if(user.companies == undefined) {
            Axios.get('https://staffapi.hebtrek.nl/v1/staff/permissions', {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }).then((response) => {
                if(response.data.includes(permission)) {
                    hasPermission = true;
                }
            }).catch((error) => {
                console.log(error)
            });
        } else {
            return true;
        }
    }
    return hasPermission;
}
